import { render, staticRenderFns } from "./tankReturnDetails.vue?vue&type=template&id=6d4fce90&scoped=true"
import script from "./tankReturnDetails.vue?vue&type=script&lang=js"
export * from "./tankReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./tankReturnDetails.vue?vue&type=style&index=0&id=6d4fce90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fce90",
  null
  
)

export default component.exports